import React, { Component } from 'react';
import { Table, Toast } from '../../../UiKit';
import Shimmer from 'sushiweb/Shimmer';
import { EmptyState } from '../../commons';
import { orderModel } from '../../../api';
import { InvalidSearchImg } from '../../../images/images';
import { getFullDate } from '../../commons/CommonMethods';
import { ChevronDown, ChevronUp } from 'sushiweb/Icons';

export default class DominosDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dominosInfo: {},
      statusDetails: null,
      showStatusDetails: false,
      showToast: false,
      toastText: '',
      toastType: 'success',
    };
    this.timer = null;
    this.tableHeading = [
      { name: 'Ticket ID', key: 1 },
      { name: 'Category', key: 2 },
      { name: 'Sub Category', key: 3 },
      { name: 'Reason', key: 4 },
      { name: 'Status', key: 5 },
    ];
    this.statusTableHeading = [
      { name: 'Resolution', key: 1 },
      { name: 'Comments', key: 2 },
      { name: 'Refund Amount', key: 3 },
      { name: 'Refund Source', key: 4 },
    ];
  }

  componentDidMount = () => {
    this.timer = setTimeout(() => {
      this.getDominosDetails();
    }, 500);
  };

  componentWillUnmount = () => {
    clearTimeout(this.timer);
  };

  getDominosDetails = () => {
    const { orderId, url } = this.props;
    if (!url) return;
    let queryStrings = {};
    queryStrings['order_id'] = orderId;

    orderModel.getDominosDetails(queryStrings, url).then((response) => {
      this.setState({
        dominosInfo: response || null,
      });
    });
  };

  openStatusDetailsTable = (content) => {
    const { showStatusDetails } = this.state;

    if (!showStatusDetails) {
      this.getStatusDetails(content);
    } else {
      this.setState({
        showStatusDetails: false,
      });
    }
  };

  getStatusDetails = (content) => {
    const { orderId } = this.props;

    if (!content.show_ticket_status.url) return;
    let url = content.show_ticket_status.url,
      queryStrings = {};
    queryStrings['order_id'] = orderId;
    queryStrings['feedback_id'] = content.feedback_id;

    return orderModel.getDominosDetails(queryStrings, url).then((response) => {
      if (!response || (response && response.isError)) {
        this.setState({
          statusDetails: null,
          showToast: true,
          toastType: 'error',
          toastText: (response && response.message) || 'Something went wrong!',
        });
        return null;
      }
      this.setState({
        statusDetails: response,
        showStatusDetails: true,
      });
      return response;
    });
  };

  getTableRows = (content) => {
    const rowsData = [];
    const { statusDetails, showStatusDetails } = this.state;
    const date = getFullDate(content.created_at);
    const obj = {
      1: {
        title: content.feedback_id || '-',
        subtitle: date,
        nestedTable:
          statusDetails && showStatusDetails
            ? {
                colSpan: 6,
                data: <Table tableData={this.getStatusTableData()} />,
                show: true,
              }
            : null,
      },
      2: {
        title: content.category || '-',
      },
      3: {
        title: content.sub_category || '-',
      },
      4: {
        title: content.reason || '-',
      },
      5: {
        title:
          content.show_ticket_status && content.show_ticket_status.name ? (
            <p
              className='pointer'
              onClick={this.openStatusDetailsTable.bind(this, content)}
            >
              <span className='text_green'>
                {content.show_ticket_status.name}
              </span>
              {showStatusDetails && statusDetails ? (
                <ChevronUp color='#50b547' />
              ) : (
                <ChevronDown color='#50b547' />
              )}
            </p>
          ) : null,
      },
    };
    rowsData.push(obj);
    return rowsData;
  };

  getStatusTableRows = () => {
    const { statusDetails } = this.state;
    const rowsData = [];
    const resolutionDate =
      statusDetails.resolution_date &&
      getFullDate(statusDetails.resolution_date);
    const refundDate =
      statusDetails.refunded_at && getFullDate(statusDetails.refunded_at);

    const obj = {
      1: {
        title: statusDetails.resolution || '-',
        subtitle: resolutionDate,
      },
      2: {
        title: statusDetails.comments || '-',
      },
      3: {
        title: statusDetails.amount || '-',
        subtitle: refundDate,
      },
      4: {
        title: statusDetails.source || '-',
      },
    };
    rowsData.push(obj);

    return rowsData;
  };

  getTableData = (content) => {
    const tableData = {
      headings: this.tableHeading,
      rows: this.getTableRows(content),
    };
    return tableData;
  };

  getStatusTableData = () => {
    const tableData = {
      headings: this.statusTableHeading,
      rows: this.getStatusTableRows(),
    };
    return tableData;
  };

  closeToast = () => {
    this.setState({
      showToast: false,
    });
  };

  render() {
    const { dominosInfo, showToast, toastText, toastType } = this.state;
    if (dominosInfo && !Object.keys(dominosInfo).length) {
      return <Shimmer height='300px' width='100%' />;
    }

    if (!dominosInfo || (dominosInfo && dominosInfo.isError)) {
      return (
        <EmptyState
          img={InvalidSearchImg}
          heading={(dominosInfo && dominosInfo.message) || 'No data available!'}
          isPop={true}
        />
      );
    } else {
      return (
        <div className='modalContent'>
          <Table tableData={this.getTableData(dominosInfo)} />
          <Toast
            show={showToast}
            align='top'
            text={toastText}
            type={toastType}
            onClose={this.closeToast}
          />
        </div>
      );
    }
  }
}
